import {useContext} from "react";
import {modalsContext} from "../providers/modalsProvider";

export function useModal() {
    return useContext(modalsContext);
}